import { isPast, secondsToMilliseconds } from 'date-fns';

import { EpgProgram } from 'store/railsBuilder/reducer.types';

import findCatchupTechnical from './findCatchupTechnical';

function isCatchupEpgProgram(program: EpgProgram) {
    return (
        isPast(secondsToMilliseconds(program.period.end)) &&
        !!findCatchupTechnical(program.editorial?.technicals)
    );
}

export default isCatchupEpgProgram;
